export default __webpack_public_path__ + "static/media/appliances_light.9c548918.png";